import React from 'react';
import cn from 'classnames';
import styles from './Card.module.scss';
import { ReactComponent as CardBgIcon } from '../../images/card_bg.svg';
import { ReactComponent as CheckIcon } from '../../images/check.svg';

type Props = {
  title: string;
  date: string;
  description: string;
  list: string[];
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  bgColor: string;
  color: string;
  isFirstCard?: boolean;
  isAfterBuy: boolean;
  onButtonClick?: () => void;
};

export function Card({
  title,
  date,
  description,
  list,
  icon,
  color,
  bgColor,
  isFirstCard,
  isAfterBuy,
  onButtonClick,
}: Props) {
  const Icon = icon;
  const afterWebTimestamp = 1778598000000; // 12 мая 15:00

  const isAfterWeb = Date.now() > afterWebTimestamp && isFirstCard;

  const cardText = isAfterBuy ? 'Доступ оформлен' : 'Оформить доступ';

  return (
    <div className={styles.root}>
      {isFirstCard && <div className={styles.background} />}
      <div className={styles.card}>
        <div className={styles.upperWrapper}>
          <div className={styles.cardBg} style={{ background: bgColor, color }}>
            <CardBgIcon />
          </div>
          <Icon className={styles.icon} />
          <p className={styles.cardTag}>прямой эфир</p>
          <p className={cn(styles.cardTitle)} dangerouslySetInnerHTML={{ __html: title }} />
          <div
            className={cn(styles.date, isAfterWeb && styles.date_ended)}
            dangerouslySetInnerHTML={{
              __html: isAfterWeb ? 'Эфир завершился' : date,
            }}
          />
        </div>
        <div className={styles.content}>
          <p className={styles.description} dangerouslySetInnerHTML={{ __html: description }} />
          <ul className={styles.list}>
            {list.map((item) => (
              <li key={item} dangerouslySetInnerHTML={{ __html: item }} />
            ))}
          </ul>
        </div>
        <button
          onClick={isAfterBuy ? undefined : onButtonClick}
          type="button"
          className={styles.button}
        >
          <div className={styles.border} />
          {cardText}
        </button>
      </div>
    </div>
  );
}
